<template>
   <v-card
          class="pa-2"
          outlined
          tile
        >
         <p class='grey--text title'>Past Medical History:</p>
         
  <v-simple-table dense v-if='currentPatient.familyHistory.length > 0'>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">Category of diagnosis</th>
          <th class="text-left">Type of diagnosis</th>
          <th class="text-left">Age diagnosed</th>
          <th class="text-left">Details</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in currentPatient.familyHistory[0].conditions" :key="item.name">
          <td>{{ item.name }}</td>
          <td>{{ item.type }}</td>
          <td>{{ item.age }}</td>
          <td>{{ item.detail }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
  <span class='red--text' v-else>The patient has not yet completed the family questionnaire.</span>
        </v-card>
</template>

<script>
export default {
    props : {
        currentPatient : Object
    }
}
</script>

<style>

</style>